import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const BACK = 'back'
export const PARTNER = 'partner'
export const NAME = 'name'
export const NUMBER = 'number'
export const EDIT = 'edit'
export const SURVEY_LINK = 'survey link'
export const SOURCE = 'source'
export const LANGUAGE = 'language'
export const LANGUAGE_PORTUGUESE = 'Portuguese'
export const LANGUAGE_SPANISH = 'spanish'
export const LANGUAGE_ENGLISH = 'english'
export const COPY_LINK = 'copy link'
export const NO_LINK = 'no link'

export default {
  [PORTUGUESE]: {
    [BACK]: 'Voltar',
    [PARTNER]: 'Parceiro',
    [NAME]: 'Nome',
    [NUMBER]: 'Número',
    [EDIT]: 'Editar',
    [SURVEY_LINK]: 'Link da Pesquisa',
    [SOURCE]: 'Fonte',
    [LANGUAGE]: 'Idioma',
    [LANGUAGE_PORTUGUESE]: 'Português',
    [LANGUAGE_SPANISH]: 'Espanhol',
    [LANGUAGE_ENGLISH]: 'Inglês',
    [COPY_LINK]: 'A cópia para a área de transferência foi bem sucedida!',
    [NO_LINK]: 'Sem link',
  },

  [ENGLISH]: {
    [BACK]: 'Back',
    [PARTNER]: 'Partner',
    [NAME]: 'Name',
    [NUMBER]: 'Number',
    [EDIT]: 'Edit',
    [SURVEY_LINK]: 'Survey Link',
    [SOURCE]: 'Source',
    [LANGUAGE]: 'Language',
    [LANGUAGE_PORTUGUESE]: 'Portuguese',
    [LANGUAGE_SPANISH]: 'Spanish',
    [LANGUAGE_ENGLISH]: 'English',
    [COPY_LINK]: 'Copying to clipboard was successful!',
    [NO_LINK]: 'No link',
  },

  [SPANISH]: {
    [BACK]: 'Atrás',
    [PARTNER]: 'Panel Externo',
    [NAME]: 'Nombre',
    [NUMBER]: 'Número',
    [EDIT]: 'Editar',
    [SURVEY_LINK]: 'Link de la Encuesta',
    [SOURCE]: 'Source',
    [LANGUAGE]: 'Idioma',
    [LANGUAGE_PORTUGUESE]: 'Portugués',
    [LANGUAGE_SPANISH]: 'Español',
    [LANGUAGE_ENGLISH]: 'Inglés',
    [COPY_LINK]: '¡Copiar al portapapeles fue exitoso!',
    [NO_LINK]: 'No link',
  },
}
